import {action, makeObservable, observable} from 'mobx';
import {showLoader, showLoaderAsync} from '../../helpers/loaders';
import {showCommunicationError, showWarning} from '../../helpers/alerts';
import {SocialLoginState} from '../../components/social-login/SocialLoginState';
import {initializeTracking, trackRegister} from '../../helpers/tracking';
import {isTestEnv} from '../../helpers/helpers';
import Cookies from 'js-cookie';

export class RegisterState extends SocialLoginState {
    @observable
    email: string = '';
    @observable
    password: string = '';
    @observable
    confirmPassword: string = '';
    @observable
    invalidData = false;
    @observable
    termsAccepted = false;


    constructor() {
        super();
        makeObservable(this);
        this.registration = true;
        this.email = this.filterEmail(new URLSearchParams(window.location.search).get('email'));
        if (!isTestEnv()) {
            initializeTracking();
        }
    }

    private filterEmail(v?: string | null): string {
        if (!v) {
            return '';
        }
        return v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }

    @action
    setEmail(v: string) {
        this.email = v.toLowerCase();
    }

    @action
    setPassword(v: string) {
        this.password = v;
    }

    @action
    setConfirmPassword(v: string) {
        this.confirmPassword = v;
    }

    @action
    setTermsAcceptance(v: boolean) {
        this.termsAccepted = v;
    }

    @action
    register() {
        if (
            !this.email ||
            !this.password ||
            !this.confirmPassword ||
            this.password !== this.confirmPassword
        ) {
            this.invalidData = true;
            return;
        }

        if (this.password.length < 12) {
            showWarning('Password too short', 'Password must be at least 12 letters long');
            this.invalidData = true;
            return '';
        }

        if (!isTestEnv()) {
            trackRegister();
            // @ts-ignore
            plausible('Registration');
        }

        showLoaderAsync(
            this.userAuthApi.apiUserAuthRegisterPost({
                registerUserLocalRequest: {
                    acceptedTermsOfUse: this.termsAccepted,
                    email: this.email,
                    confirmPassword: this.confirmPassword,
                    password: this.password,
                    acquisitionSource: Cookies.get('utm_source'),
                    registrationToken: new URLSearchParams(window.location.search).get('registrationToken'),
                },
            }).then((res) => {
                if (res.errors && res.errors.length > 0) {
                    showWarning('Cannot register', res.errors[0]);
                } else {
                    showLoader();
                    setTimeout(() => {
                        document.location.reload();
                    }, 1000);
                }

            }).catch((err) => {
                showCommunicationError(err);
            }));
    }
}
